
import PieChart from '@/components/status-bar/components/charts/pie-chart';

export default {
  components: {
    PieChart,
  },
  props: ['chartData'],
};
